import { render, staticRenderFns } from "./BatchRenewal.vue?vue&type=template&id=3206dd44&"
import script from "./BatchRenewal.vue?vue&type=script&lang=js&"
export * from "./BatchRenewal.vue?vue&type=script&lang=js&"
import style0 from "./BatchRenewal.vue?vue&type=style&index=0&id=3206dd44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports